// extracted by mini-css-extract-plugin
export default {"productsDrawerButton":"ProductsDrawerButton_productsDrawerButton__Oel56"};